export enum DocumentSubTypeObjectAttributeNameEnum {
  NAME = 'name__a',
  CODE = 'code__a',
  TITLE = 'title__a',
  DOCUMENT_TYPE = 'document_type__a',
  DOCUMENT_TEMPLATE = 'document_template__a',
  IS_TRAINABLE = 'is_trainable__a',
  IS_FOLLOW_UP_REQUIRED = 'is_follow_up_required__a',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'follow_up_time_period_in_months__a',
  IS_ADMIN_REVIEW_REQUIRED = 'is_admin_review_required__a',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectiveness_in_days__a',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'is_raw_file_download_allowed__a',
  IS_ADMIN_APPROVAL_REQUIRED = 'is_admin_approval_required__a',
  TEMPLATE_NAME = 'template_name__a',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'follow_up_trigger_periods_in_days__a',
}

export enum DocumentSubTypeObjectKeyEnum {
  NAME = 'name',
  LABEL = 'label',
  CODE = 'code',
  TITLE = 'title',
  DOCUMENT_TYPE = 'documentType',
  DOCUMENT_TEMPLATE = 'documentTemplate',
  IS_TRAINABLE = 'isTrainable',
  IS_FOLLOW_UP_REQUIRED = 'isFollowUpRequired',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'followUpTimePeriodInMonths',
  IS_ADMIN_REVIEW_REQUIRED = 'isAdminReviewRequired',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectivenessPeriodInDays',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'isRawFileDownloadAllowed',
  IS_ADMIN_APPROVAL_REQUIRED = 'isAdminApprovalRequired',
  TEMPLATE_NAME = 'templateName',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'followUpTriggerPeriodInDays',
}

export enum DocumentSubTypeObjectColumnNameEnum {
  NAME = 'name',
  LABEL = 'label',
  CODE = 'code',
  TITLE = 'title',
  DOCUMENT_TYPE = 'documentType',
  DOCUMENT_TEMPLATE = 'documentTemplate',
  IS_TRAINABLE = 'isTrainable',
  IS_FOLLOW_UP_REQUIRED = 'isFollowUpRequired',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'followUpTimePeriodInMonths',
  IS_ADMIN_REVIEW_REQUIRED = 'isAdminReviewRequired',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectivenessPeriodInDays',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'isRawFileDownloadAllowed',
  IS_ADMIN_APPROVAL_REQUIRED = 'isAdminApprovalRequired',
  TEMPLATE_NAME = 'templateName',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'followUpTriggerPeriodInDays',
}
